import { RoleName } from "../constants";
import { IRole } from "../store/types/user";

export const leaveExternalRoles = (roles: IRole[]): IRole[] => {
  if (!roles?.length) {
    return [];
  }
  return roles?.filter((role: IRole) => {
    return role.id === 2 || role.id === 3 || role.id === 5 || role.id === 7;
  });
};

export const isRoleAnalyst = ({
  role,
  preventTV,
  preventUser
}: {
  role: IRole | null;
  preventTV?: boolean; //team-viewer
  preventUser?: boolean; //team-member
}): boolean => {
  if (!role) return false;
  if (role.name === RoleName.Analyst && preventUser) return false; //prevent it's flag if we need to added access restriction  in some specific cases
  if (role.name === RoleName.TeamViewer && preventTV) return false; //prevent it's flag if we need to added access restriction  in some specific cases
  return role.name === RoleName.Admin || role.name === RoleName.Analyst || role.name === RoleName.TeamViewer;
};
